var map = {
	"./anhui.js": [
		"LxaZ",
		33
	],
	"./aomen.js": [
		"bFhG",
		32
	],
	"./beijing.js": [
		"bIQF",
		31
	],
	"./chongqing.js": [
		"yOrR",
		30
	],
	"./fujian.js": [
		"MF5D",
		29
	],
	"./gansu.js": [
		"wlbM",
		28
	],
	"./guangdong.js": [
		"q8av",
		27
	],
	"./guangxi.js": [
		"d+A2",
		26
	],
	"./guizhou.js": [
		"gQu3",
		25
	],
	"./hainan.js": [
		"lWJF",
		24
	],
	"./hebei.js": [
		"fl3M",
		23
	],
	"./heilongjiang.js": [
		"rugJ",
		22
	],
	"./henan.js": [
		"uf2Q",
		21
	],
	"./hubei.js": [
		"BrxA",
		20
	],
	"./hunan.js": [
		"Bu9l",
		19
	],
	"./jiangsu.js": [
		"aM2Z",
		18
	],
	"./jiangxi.js": [
		"sLa+",
		17
	],
	"./jilin.js": [
		"RXgU",
		16
	],
	"./liaoning.js": [
		"4h20",
		15
	],
	"./neimenggu.js": [
		"+kzi",
		14
	],
	"./ningxia.js": [
		"DvFz",
		13
	],
	"./qinghai.js": [
		"+EQR",
		12
	],
	"./shandong.js": [
		"H/fg",
		11
	],
	"./shanghai.js": [
		"2UcM",
		10
	],
	"./shanxi.js": [
		"OPXM",
		9
	],
	"./shanxi1.js": [
		"GxeG",
		8
	],
	"./sichuan.js": [
		"LM7n",
		7
	],
	"./taiwan.js": [
		"2JxT",
		6
	],
	"./tianjin.js": [
		"ZpZ2",
		5
	],
	"./xianggang.js": [
		"Zb2g",
		4
	],
	"./xinjiang.js": [
		"3AnA",
		3
	],
	"./xizang.js": [
		"NWZx",
		2
	],
	"./yunnan.js": [
		"aZfD",
		1
	],
	"./zhejiang.js": [
		"Knpt",
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "qiKX";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/echarts/map/js/province lazy ^\.\/.*\.js$
// module id = qiKX
// module chunks = 39